import { env } from '@/platform/env';

const BASE_URL = `${env.apiUrl.replace(/\/api\/?$/, '')}/thayminhtue`;

const ADMIN_URL = {
  /* Hệ thống/Người sử dụng */
  USER: `${BASE_URL}/auth/user`,

  /* Hệ thống/Nhóm người sử dụng */
  GROUPS_USER: `${BASE_URL}/auth/group`,

  /* Công cụ/Khai báo thông tin công cụ dụng cụ */
  CONG_CU_DUNG_CU: `${BASE_URL}/django_ledger/khaibaothongtinccdcmodel`,

  /* Tài sản/Khai báo thông tin tài sản cố định */
  TAI_SAN_CO_DINH: `${BASE_URL}/django_ledger/khaibaothongtintaisancodinhmodel`,

  /* Danh mục/Vật tư, sản phẩm */
  VAT_TU: `${BASE_URL}/django_ledger/vattumodel`,

  /* Danh mục/Thuế/Thuế suất thuế GTGT */
  THUE_SUAT_THUE_GTGT: `${BASE_URL}/django_ledger/thuesuatthuegtgtmodel`,

  /* Danh mục/Thuế/Thuế suất thuế nhập khẩu */
  THUE_SUAT_THUE_NHAP_KHAU: `${BASE_URL}/django_ledger/thuesuatthuenhapkhauthuegtgtmodel`,

  /* Hệ thống/Chứng từ/Cấu trúc quyền số chứng từ */
  QUYEN_CHUNG_TU: `${BASE_URL}/django_ledger/quyenchungtu`
};

export default ADMIN_URL;
